import Schema from 'AppReact/schema';
import { defaultTech, property, tech } from './types';

export default {
  tech: Schema(tech, 'object', { defaultValue: defaultTech }),
  loadingStats: Schema('boolean', 'primitive-nullable', { defaultValue: false }),
  properties: Schema(property, 'array', { defaultValue: [] }),
  hideWithdrawn: Schema('boolean', 'primitive-nullable', { defaultValue: false }),
  showCoins: Schema('boolean', 'primitive-nullable', { defaultValue: false }),
}